import axios from 'axios'

export const axiosInstance = axios.create({
  baseURL: "https://sandboxhost.thryft.io"
})